import React, { useRef } from "react";
import { bool, func, string } from "prop-types";
import { useTranslation } from "@lib/i18n";

import { Button } from "./Button";
import Modal from "./Modal";
import RequestButton from "./RequestButton";
import Typography from "./Typography";

const PreconfigurationModal = ({ isOpen, onConfirm, onCancel, dataId }) => {
  const { t } = useTranslation();

  const modalFirstElement = useRef(null);
  const modalLastElement = useRef(null);

  return (
    <Modal
      ariaLabel={t("preconfiguration.heading")}
      firstElement={modalFirstElement}
      isOpen={isOpen}
      lastElement={modalLastElement}
      onClose={onCancel}
    >
      <div
        className="flex flex-col items-center h-full gap-8 py-4 text-center"
        data-id={`${dataId}-modal-container`}
      >
        <h4 className="text-xl font-semibold">
          {t("preconfiguration.heading")}
        </h4>
        <Typography>{t("preconfiguration.description")}</Typography>
        <div className="flex flex-wrap items-center justify-center gap-4 w-full">
          <RequestButton
            data-id={`${dataId}-change-confirm-btn`}
            ref={modalFirstElement}
            triggerRequestCallback={onConfirm}
          >
            {t("general.accept")}
          </RequestButton>
          <Button
            data-id={`${dataId}-change-cancel-btn`}
            onClick={onCancel}
            ref={modalLastElement}
            variant="secondary"
          >
            {t("general.cancel")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

PreconfigurationModal.propTypes = {
  isOpen: bool.isRequired,
  onConfirm: func,
  onCancel: func,
  dataId: string,
};

export default PreconfigurationModal;
